// Toast with Sound - Wrapper for sonner toast with notification sounds
import { toast as sonnerToast } from 'sonner';
import notificationSound from './notificationSound';

// Initialize audio context on first user interaction
let audioInitialized = false;

const initAudio = () => {
  if (!audioInitialized) {
    notificationSound.init();
    audioInitialized = true;
  }
};

// Wrapper that adds sound to toasts
export const toast = {
  success: (message, options) => {
    initAudio();
    notificationSound.playSuccess();
    return sonnerToast.success(message, options);
  },
  
  error: (message, options) => {
    initAudio();
    notificationSound.playError();
    return sonnerToast.error(message, options);
  },
  
  info: (message, options) => {
    initAudio();
    notificationSound.playChime();
    return sonnerToast.info(message, options);
  },
  
  warning: (message, options) => {
    initAudio();
    notificationSound.playError();
    return sonnerToast.warning(message, options);
  },
  
  message: (message, options) => {
    initAudio();
    notificationSound.playMessage();
    return sonnerToast.message(message, options);
  },
  
  // For custom toasts without sound
  silent: sonnerToast,
  
  // Promise toast with sounds
  promise: (promise, options) => {
    initAudio();
    notificationSound.playPop();
    return sonnerToast.promise(promise, {
      ...options,
      success: (data) => {
        notificationSound.playSuccess();
        return options?.success?.(data) || 'Success!';
      },
      error: (err) => {
        notificationSound.playError();
        return options?.error?.(err) || 'Error occurred';
      },
    });
  },
  
  // Loading toast
  loading: (message, options) => {
    initAudio();
    notificationSound.playPop();
    return sonnerToast.loading(message, options);
  },
  
  // Dismiss
  dismiss: sonnerToast.dismiss,
};

// Sound settings component helper
export const getSoundSettings = () => ({
  enabled: notificationSound.enabled,
  volume: notificationSound.volume,
});

export const setSoundEnabled = (enabled) => {
  notificationSound.setEnabled(enabled);
};

export const setSoundVolume = (volume) => {
  notificationSound.setVolume(volume);
};

export default toast;
